module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-t-mobile-02.c76f9a7d.jpg";